import useModalStore from "zustand/zustandstore";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

const Addpatient=({setPatientId,setPatientName, patientName,patientId,errorMessage,
  isDetailsmoadal, setDetailsModal,setErrorMessage,handleStartRecording
})=>{
  const mydata = useModalStore();


if(!isDetailsmoadal){
  return
}

    return(<>
     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-4 sm:p-6 min-h-[50vh] rounded-[15px] shadow-lg w-[90%] sm:w-[70%] max-w-md relative flex flex-col">
        <button
          onClick={() => {
            setPatientName('');
            setPatientId('');
            setDetailsModal(false)

          }}
          className="absolute top-2 right-2 text-gray-600 hover:text-black"
        >
          <CloseIcon />
        </button>
        <div className="flex flex-col items-center mt-5 justify-between flex-grow">
          <div className="mb-4 text-center">
          {mydata.usertype === 'BUSINESS'?<> <div className="font-bold text-[#1C2A3A] text-lg sm:text-xl leading-7">Add Details</div></>:<div className="font-bold text-[#1C2A3A] text-lg sm:text-xl leading-7">Add Patient Details</div>
          }</div>

          {/* Patient Name Input */}
          {mydata.usertype === 'BUSINESS'?<>
            <div className=" mb-4 flex flex-col  w-[80%] mx-auto">
 <label className="text-start text-md w-full font-semibold mb-2">Name</label>
   <div className="">
         
            <input
              type="text"
              value={patientName}
              onChange={(e) => {
                if (errorMessage) setErrorMessage('');
                setPatientName(e.target.value);
              }}
              placeholder="Enter Conversation Name"
              className="w-full bg-transparent h-[45px] border border-gray-300 p-3  rounded-lg outline-none text-gray-800 text-sm font-normal"
            />
            {/* <img src={usericon} alt="User Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" /> */}
          </div></div>
          <div className=" mb-4 w-[80%] flex flex-col mx-auto">
            <label className="text-start text-md w-full font-semibold mb-2">Notes</label>
            <textarea
              value={patientId}
              onChange={(e) => {
                if (errorMessage) setErrorMessage('');
                setPatientId(e.target.value);
              }}
              placeholder=""
              rows="6"
              className="w-full bg-transparent border border-gray-300 p-3  rounded-lg outline-none text-gray-800 text-sm font-normal resize-none"
            ></textarea>
        
          </div>
          
          </>:<><div className="relative mb-4 w-[80%] mx-auto">
            <input
              type="text"
              value={patientName}
              onChange={(e) => {
                if (errorMessage) setErrorMessage('');
                setPatientName(e.target.value);
              }}
              placeholder="Enter Patient Name"
              className="w-full bg-transparent h-[45px] border border-gray-300 p-3 pl-10 rounded-lg outline-none text-gray-800 text-sm font-normal"
            />
          </div>

          {/* Patient ID Input */}
          <div className="relative mb-4 w-[80%] mx-auto">
            <input
              type="text"
              value={patientId}
              onChange={(e) => {
                const value = e.target.value;
  
                if (/[^0-9]/.test(value)) return; // Allow only numeric characters
                if (errorMessage) setErrorMessage('');
                setPatientId(value);
              }}
              placeholder="Enter Patient ID"
              className="w-full bg-transparent h-[45px] border border-gray-300 p-3 pl-10 rounded-lg outline-none text-gray-800 text-sm font-normal"
            />
          </div>
          </>}
 


          {/* Error Message */}
          {errorMessage && (
            <div className="text-red-500 text-xs sm:text-sm mb-4 w-[80%] mx-auto">
              {errorMessage}
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex items-center justify-center mt-4 gap-5 w-full">
            <button
               onClick={()=>{
 
                handleStartRecording()}}
              className="w-[40%] p-4 h-10 bg-[#1c2a3a] text-white text-sm font-semibold rounded-[14px] flex items-center justify-center"
            >
              Start Recording
            </button>
            <button
              onClick={() => {
                setPatientName('');
                setPatientId('');         
               setDetailsModal(false)
              }}
              className="w-[40%] p-4 h-10 bg-[#1c2a3a] text-white text-sm font-semibold rounded-[14px] flex items-center justify-center"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  
    </>)
}
export default Addpatient